import Close from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import { useEventTracking } from 'hooks/useEventTracking';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { SectionProducts } from './components/SectionProducts/SectionProducts';
import { SectionSearch } from './components/SectionSearch/SectionSearch';
import { SectionVoucherInfo } from './components/SectionVoucherInfo/SectionVoucherInfo';
import { WrapperValidateCart } from './components/WrapperValidateCart/WrapperValidateCart';
import { useVoucherDetailContext, VoucherDetailProvider } from './PageVoucherDetail.context';
import { getItemParamTracking } from './utils/getItemParamTracking';

interface Props {
  code: string;
  open?: boolean;
  onClose?: () => void;
}

const DEFAULT_VALUES = {
  page: 1,
  search: '',
};

export const ModalVoucherDetail = ({ code, open, onClose }: Props) => {
  const form = useForm({
    defaultValues: DEFAULT_VALUES,
  });

  useEffect(() => {
    form.reset(DEFAULT_VALUES);
  }, [open]);

  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '80vw',
          paddingTop: '60px',
          background: 'transparent',
          boxShadow: 'none',
        },
      }}
      className="relative"
      open={!!open}
      onClose={onClose}
      disableScrollLock={true}
    >
      <div className="absolute top-[20px] right-0 z-10">
        <div className="flex gap-2 items-center !text-white cursor-pointer" onClick={onClose}>
          <p className="text-[14px]">Đóng</p>
          <Close className="!text-white" />
        </div>
      </div>
      <WrapperValidateCart open={open}>
        <FormProvider {...form}>
          <VoucherDetailProvider code={code}>
            <Render />
          </VoucherDetailProvider>
        </FormProvider>
      </WrapperValidateCart>
    </Dialog>
  );
};

const Render = () => {
  const { onClick, onMouseMove } = useEventTracking({
    getItemParamTracking,
  });

  const { voucherInfo } = useVoucherDetailContext();

  const trackingData = voucherInfo
    ? {
        'data-short-name': voucherInfo.shortName,
        'data-code': voucherInfo.code,
        'data-expired-date': voucherInfo.endTime,
        'data-action-status': voucherInfo.actionStatus,
        'data-seller-name': voucherInfo.sellerName,
        'data-usage-total': voucherInfo.usageTotal,
      }
    : {};

  return (
    <div
      data-root-voucher=""
      {...trackingData}
      className="w-[80vw] max-h-[1000px] h-[80vh] xl:w-[1028px] mx-auto px-0 space-y-4 font-[ggsm] overflow-x-hidden overflow-y-auto pb-3 bg-white"
      {...{ onClick, onMouseMove }}
    >
      <SectionVoucherInfo />
      <SectionSearch className="mx-2 !w-auto" />
      <SectionProducts
        limitPerPage={12}
        className="!grid-cols-1 md:!grid-cols-2 lg:!grid-cols-3 xl:!grid-cols-4 gap-4 bg-[#f5f5f5] p-6 [&>div]:max-w-full [&>div]:min-w-[220px]"
      />
    </div>
  );
};

